<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        
        
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="w-[200px]">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{ user.firstName }} {{ user.lastName }}</span>
            <!-- <span class="mt-1.5 text-md font-medium">{{ user.email }}</span> -->
            <span class="mt-1.5 text-md font-medium">[{{ user.role }}]</span> 
        </span>
    </button>
    @if (agentLogged$ | async; as agent) 
    {
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item>
            <span class="flex flex-col leading-none"> 
                <span class="mt-1.5 text-md font-medium">{{ agent.name }}</span>
                <span class="mt-1.5 text-md font-medium">{{ agent.email }}</span>
            </span>
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profilo</span>
    </button>
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button> -->

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Logout</span>
    </button>
</mat-menu>
